"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stratopolis = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const SpaceName_1 = require("../../SpaceName");
const SpaceType_1 = require("../../SpaceType");
const Resources_1 = require("../../Resources");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Card_1 = require("../Card");
class Stratopolis extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.STRATOPOLIS,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.VENUS],
            cost: 22,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 2)),
            metadata: {
                cardNumber: '248',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 2 floaters to ANY VENUS CARD.', (eb) => {
                        eb.empty().startAction.floaters(2).secondaryTag(Tags_1.Tags.VENUS);
                    }).br;
                    b.production((pb) => pb.megacredits(2)).city().asterix();
                    b.vpText('1 VP for every 3rd Floater on this card.');
                }),
                description: {
                    text: 'Requires 2 science tags. Increase your M€ production 2 steps. Place a City tile ON THE RESERVED AREA',
                    align: 'left',
                },
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.floaters(1, 3),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.game.addCityTile(player, SpaceName_1.SpaceName.STRATOPOLIS, SpaceType_1.SpaceType.COLONY);
        return undefined;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 3);
    }
    getResCards(player) {
        const resourceCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        return resourceCards.filter((card) => card.tags.some((cardTag) => cardTag === Tags_1.Tags.VENUS));
    }
    canAct() {
        return true;
    }
    action(player) {
        const cards = this.getResCards(player);
        if (cards.length === 1) {
            player.addResourceTo(cards[0], { qty: 2, log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add 2 floaters', 'Add floater(s)', cards, (foundCards) => {
            player.addResourceTo(foundCards[0], { qty: 2, log: true });
            return undefined;
        });
    }
}
exports.Stratopolis = Stratopolis;
//# sourceMappingURL=Stratopolis.js.map